import {
  Box,
  Button,
  ButtonGroup,
  Grid,
  GridItem,
  Text,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  Input,
  Icon,
  Tooltip,
  Select,
  Card,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  getFarmer,
  getGeoCodes,
  getSuggestions,
  updateFarm,
  deleteFarm,
  updateFarmer,
  deleteFarmer,
} from "../../api";
import isAllowed from "../../routing/isAllowed";
import { IoChevronBackCircleSharp } from "react-icons/io5";
import { FaEdit } from "react-icons/fa";
import { statesList } from "../../Common/utils";
import { toast } from "react-toastify";

function FarmerDetails() {
  const [farmerData, setFarmerData] = useState({});
  const [editable, setEditable] = useState(false);
  const [farmSuggestions, setFarmSuggestions] = useState([]);
  const [openFarmSuggestions, setOpenFarmSuggestions] = useState(false);
  const { id } = useParams();
  const [refetch, setRefetch] = useState(false);
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate("/supplier");
  };

  const getFarmerData = async () => {
    let response = await getFarmer(encodeURIComponent(id));
    setFarmerData(response?.data);
  };

  const handleDeleteFarm = async (id) => {
    try {
      const response = await deleteFarm(id);
      if (response?.status === "success") {
        toast.success("Farm deleted Successfully");
      }
    } catch (err) {
      console.log(err);
    }
    setRefetch(!refetch);
  };

  const handleDeleteFarmer = async (id) => {
    try {
      const response = await deleteFarmer(id);
      if (response?.status === "success") {
        toast.success("Farmer deleted Successfully");
      }
    } catch (err) {
      console.log(err);
    }
    setRefetch(!refetch);
  };

  const handleUpdateFarmer = async (values, id) => {
    const { farmer_farm_details, ...updatedValues } = values;

    try {
      const response = await updateFarmer(updatedValues, id);
      if (response?.status === "success") {
        toast.success("Farmer updated Successfully");
      }
    } catch (err) {
      console.log(err);
    }
    setRefetch(!refetch);
  };

  const handleUpdateFarm = async (values, id) => {
    try {
      const response = await updateFarm(values, id);
      if (response?.status === "success") {
        toast.success("Farm updated Successfully");
      }
    } catch (err) {
      console.log(err);
    }
    setRefetch(!refetch);
  };

  const handleEditClick = () => {
    setEditable(!editable);
  };

  const handleChange = (e, field, farmIndex = null, farmField = null) => {
    const value = e.target.value;
    if (farmIndex !== null && farmField !== null) {
      const updatedFarms = [...farmerData.farmer_farm_details];
      const fields = farmField.split(".");
      if (fields.length > 1) {
        let currentLevel = updatedFarms[farmIndex];
        for (let i = 0; i < fields.length - 1; i++) {
          currentLevel = currentLevel[fields[i]];
        }
        currentLevel[fields[fields.length - 1]] = value;
      } else {
        updatedFarms[farmIndex][farmField] = value;
      }
      setFarmerData({ ...farmerData, farmer_farm_details: updatedFarms });
    } else {
      const fields = field.split(".");
      if (fields.length > 1) {
        const updatedFarmerData = { ...farmerData };
        let currentLevel = updatedFarmerData;
        for (let i = 0; i < fields.length - 1; i++) {
          currentLevel = currentLevel[fields[i]];
        }
        currentLevel[fields[fields.length - 1]] = value;
        setFarmerData(updatedFarmerData);
      } else {
        setFarmerData({ ...farmerData, [field]: value });
      }
    }
  };

  const getFarmSuggestions = async (address) => {
    const response = await getSuggestions(address);
    setFarmSuggestions(response?.data?.predictions);
  };

  const setFarmGeoCode = async (address, index) => {
    const response = await getGeoCodes(address);
    const coordinates = response?.data?.location;
    const updatedFarms = [...farmerData.farmer_farm_details];

    updatedFarms[index].address.location.coordinates[0] = coordinates.lat;
    updatedFarms[index].address.location.coordinates[1] = coordinates.lng;

    setFarmerData({ ...farmerData, farmer_farm_details: updatedFarms });
  };

  const handleSuggestionClick = async (suggestion, index) => {
    handleChange(
      { target: { value: suggestion } },
      "address.raw_address",
      index,
      "address.raw_address"
    );
    await setFarmGeoCode(suggestion, index);
    setOpenFarmSuggestions(false);
  };

  useEffect(() => {
    getFarmerData();
  }, [id, refetch]);

  return (
    <>
      <Box marginBottom={"2rem"}>
        <Box
          display={"flex"}
          alignItems="center"
          cursor={"pointer"}
          onClick={handleGoBack}
        >
          <IoChevronBackCircleSharp color={"#52BBFF"} size={30} />
          &nbsp;
          <Text
            color={"#52BBFF"}
            fontSize={{ base: "sm", md: "sm", lg: "md" }}
            fontWeight={"800"}
            fontFamily={"font.roboto"}
          >
            Go Back
          </Text>
        </Box>
        <Box marginTop="2rem">
          <Text
            color={"#141D43"}
            fontSize="2xl"
            fontWeight={"800"}
            fontFamily={"font.roboto"}
          >
            Farmers Details
          </Text>
          <Text color={"#3958DC"} fontSize="sm">
            Details of the farmer
          </Text>
        </Box>
        <Box
          marginTop={"1.5rem"}
          bg={
            "linear-gradient(90deg, rgba(81,187,255,1) 0%, rgba(81,187,255,1) 15%, rgba(164,206,255,1) 100%)"
          }
          borderTopRightRadius="100px"
          borderBottomRightRadius={"80px 80px"}
          color={"#fff"}
          padding={"10px 2rem"}
          fontWeight="700"
          marginLeft="-2rem"
          marginRight={"-2.5rem"}
          display="flex"
          alignItems="center"
          gap="1rem"
        >
          <Text>Personal Details</Text>{" "}
          <Icon
            _hover={{ cursor: "pointer" }}
            as={FaEdit}
            onClick={handleEditClick}
          />
        </Box>
        <Box
          bg="white"
          p={"1rem"}
          mt="2rem"
          borderRadius="15px"
          boxShadow={"rgba(100, 100, 111, 0.2) 0px 10px 26px 0px"}
        >
          <Box p="1rem">
            <Grid
              templateColumns="repeat(3, 1fr)"
              marginTop={"1rem"}
              gap={editable ? "1rem" : ""}
            >
              <GridItem colSpan={1}>
                <Text
                  color={"#141D43"}
                  fontSize="md"
                  fontWeight={"700"}
                  fontFamily={"font.roboto"}
                >
                  First Name
                </Text>
                {editable ? (
                  <Input
                    value={farmerData?.firstName || ""}
                    onChange={(e) => handleChange(e, "firstName")}
                    mt="1rem"
                  />
                ) : (
                  <Text color={"#464C64"} fontSize="sm" mt="1rem">
                    {farmerData?.firstName ? farmerData?.firstName : "N/A"}
                  </Text>
                )}
              </GridItem>
              <GridItem>
                <Text
                  color={"#141D43"}
                  fontSize="md"
                  fontWeight={"700"}
                  fontFamily={"font.roboto"}
                >
                  Last Name
                </Text>
                {editable ? (
                  <Input
                    value={farmerData?.lastName || ""}
                    onChange={(e) => handleChange(e, "lastName")}
                    mt="1rem"
                  />
                ) : (
                  <Text color={"#464C64"} fontSize="sm" mt="1rem">
                    {farmerData?.lastName ? farmerData?.lastName : "N/A"}
                  </Text>
                )}
              </GridItem>
            </Grid>
          </Box>
          <Box p="1rem">
            <Grid
              templateColumns="repeat(3, 1fr)"
              marginTop={"1rem"}
              gap={editable ? "1rem" : ""}
            >
              <GridItem>
                <Text
                  color={"#141D43"}
                  fontSize="md"
                  fontWeight={"700"}
                  fontFamily={"font.roboto"}
                >
                  Email
                </Text>
                {editable ? (
                  <Input
                    value={farmerData?.contactInfo?.email || ""}
                    onChange={(e) => handleChange(e, "contactInfo.email")}
                    mt="1rem"
                  />
                ) : (
                  <Text color={"#464C64"} fontSize="sm" mt="1rem">
                    {farmerData?.contactInfo?.email
                      ? farmerData?.contactInfo?.email
                      : "N/A"}
                  </Text>
                )}
              </GridItem>
              <GridItem>
                <Text
                  color={"#141D43"}
                  fontSize="md"
                  fontWeight={"700"}
                  fontFamily={"font.roboto"}
                >
                  Farmer ID
                </Text>
                {editable ? (
                  <Input
                    value={farmerData?.id || ""}
                    onChange={(e) => handleChange(e, "id")}
                    mt="1rem"
                    isDisabled="true"
                  />
                ) : (
                  <Text color={"#464C64"} fontSize="sm" mt="1rem">
                    {farmerData?.id ? farmerData?.id : "N/A"}
                  </Text>
                )}
              </GridItem>
            </Grid>
          </Box>
          <Box p="1rem">
            <Grid
              templateColumns="repeat(3, 1fr)"
              marginTop={"1rem"}
              gap={editable ? "1rem" : ""}
            >
              <GridItem>
                <Text
                  color={"#141D43"}
                  fontSize="md"
                  fontWeight={"700"}
                  fontFamily={"font.roboto"}
                >
                  Aadhar Number / Any ID Proof
                </Text>
                {editable ? (
                  <Input
                    value={farmerData?.idProof || ""}
                    onChange={(e) => handleChange(e, "idProof")}
                    mt="1rem"
                  />
                ) : (
                  <Text color={"#464C64"} fontSize="sm" mt="1rem">
                    {farmerData?.idProof ? farmerData?.idProof : "N/A"}
                  </Text>
                )}
              </GridItem>
            </Grid>
          </Box>
          <Box p="1rem">
            <Grid
              templateColumns="repeat(3, 1fr)"
              marginTop={"1rem"}
              gap={editable ? "1rem" : ""}
            >
              <GridItem colSpan={1}>
                <Text
                  color={"#141D43"}
                  fontSize="md"
                  fontWeight={"700"}
                  fontFamily={"font.roboto"}
                >
                  Contact Number
                </Text>
                {editable ? (
                  <Input
                    value={farmerData?.contactInfo?.phone || ""}
                    onChange={(e) => handleChange(e, "contactInfo.phone")}
                    mt="1rem"
                  />
                ) : (
                  <Text color={"#464C64"} fontSize="sm" mt="1rem">
                    {farmerData?.contactInfo?.phone
                      ? farmerData?.contactInfo?.phone
                      : "N/A"}
                  </Text>
                )}
              </GridItem>
              <GridItem>
                <Text
                  color={"#141D43"}
                  fontSize="md"
                  fontWeight={"700"}
                  fontFamily={"font.roboto"}
                >
                  Pincode
                </Text>
                {editable ? (
                  <Input
                    value={farmerData?.address?.pinCode || ""}
                    onChange={(e) => handleChange(e, "address.pinCode")}
                    mt="1rem"
                  />
                ) : (
                  <Text color={"#464C64"} fontSize="sm" mt="1rem">
                    {farmerData?.address?.pinCode
                      ? farmerData?.address?.pinCode
                      : "N/A"}
                  </Text>
                )}
              </GridItem>
            </Grid>
          </Box>
          <Box p="1rem">
            <Grid
              templateColumns="repeat(3, 1fr)"
              marginTop={"1rem"}
              gap={editable ? "1rem" : ""}
            >
              <GridItem colSpan={1}>
                <Text
                  color={"#141D43"}
                  fontSize="md"
                  fontWeight={"700"}
                  fontFamily={"font.roboto"}
                >
                  Address
                </Text>
                {editable ? (
                  <Input
                    value={farmerData?.address?.raw_address || ""}
                    onChange={(e) => {
                      handleChange(e, "address.raw_address");
                    }}
                    mt="1rem"
                  />
                ) : (
                  <Text color={"#464C64"} fontSize="sm" mt="1rem">
                    {farmerData?.address?.raw_address
                      ? farmerData?.address?.raw_address
                      : "N/A"}
                  </Text>
                )}
              </GridItem>
            </Grid>
          </Box>
          <Box p="1rem">
            <Grid
              templateColumns="repeat(3, 1fr)"
              marginTop={"1rem"}
              gap={editable ? "1rem" : ""}
            >
              <GridItem colSpan={1}>
                <Text
                  color={"#141D43"}
                  fontSize="md"
                  fontWeight={"700"}
                  fontFamily={"font.roboto"}
                >
                  City
                </Text>
                {editable ? (
                  <Input
                    value={farmerData?.address?.city || ""}
                    onChange={(e) => handleChange(e, "address.city")}
                    mt="1rem"
                  />
                ) : (
                  <Text color={"#464C64"} fontSize="sm" mt="1rem">
                    {farmerData?.address?.city
                      ? farmerData?.address?.city
                      : "N/A"}
                  </Text>
                )}
              </GridItem>
              <GridItem colSpan={1}>
                <Text
                  color={"#141D43"}
                  fontSize="md"
                  fontWeight={"700"}
                  fontFamily={"font.roboto"}
                >
                  State
                </Text>
                {editable ? (
                  <Select
                    value={farmerData?.address?.state || ""}
                    onChange={(e) => handleChange(e, "address.state")}
                    mt="1rem"
                  >
                    <option hidden="true">Select Your State</option>
                    {statesList.map((state, index) => (
                      <option key={index}>{state}</option>
                    ))}
                  </Select>
                ) : (
                  <Text color={"#464C64"} fontSize="sm" mt="1rem">
                    {farmerData?.address?.state
                      ? farmerData?.address?.state
                      : "N/A"}
                  </Text>
                )}
              </GridItem>
            </Grid>
          </Box>
          <Box p="1rem">
            {" "}
            {editable && (
              <ButtonGroup gap="1rem">
                <Button
                  bg="#52BBFF"
                  mt="2rem"
                  w="193px"
                  h="50px"
                  color={"#fff"}
                  _hover={{ bg: "#52BBFF" }}
                  onClick={() => handleUpdateFarmer(farmerData, id)}
                >
                  Update Farmer
                </Button>
              </ButtonGroup>
            )}
          </Box>
        </Box>
        <Box
          marginTop={"2rem"}
          color={"#fff"}
          padding={"10px 2rem"}
          fontWeight="700"
          marginLeft="-2rem"
          bg={
            "linear-gradient(90deg, rgba(81,187,255,1) 0%, rgba(81,187,255,1) 15%, rgba(164,206,255,1) 100%)"
          }
          borderTopRightRadius="100px"
          borderBottomRightRadius={"80px"}
          marginRight={"-2.5rem"}
        >
          Farm Details
        </Box>

        {farmerData?.farmer_farm_details?.length > 0 ? (
          <Accordion allowToggle defaultIndex={[0]} mt={"1rem"}>
            {farmerData?.farmer_farm_details?.map((farm, index) => (
              <AccordionItem
                key={index}
                bg="white"
                boxShadow={"rgba(100, 100, 111, 0.2) 0px 10px 26px 0px"}
              >
                <AccordionButton display={"flex"} alignItems={"center"}>
                  <Box
                    marginTop={"1rem"}
                    color={"black"}
                    padding={"10px 1rem"}
                    fontWeight="700"
                  >
                    Farm Detail {index + 1}
                  </Box>
                  <AccordionIcon mt={"10px"} />
                </AccordionButton>
                <AccordionPanel>
                  <Box p={"1rem"} mt="-1rem" borderRadius="15px">
                    <Box p="1rem">
                      <Grid
                        templateColumns="repeat(3, 1fr)"
                        marginTop={"1rem"}
                        gap={editable ? "1rem" : ""}
                      >
                        <GridItem colSpan={1}>
                          <Text
                            color={"#141D43"}
                            fontSize="md"
                            fontWeight={"700"}
                            fontFamily={"font.roboto"}
                          >
                            Land Size (Acres)
                          </Text>
                          {editable ? (
                            <Input
                              value={farm?.landSize || ""}
                              onChange={(e) =>
                                handleChange(e, "landSize", index, "landSize")
                              }
                              mt="1rem"
                            />
                          ) : (
                            <Text color={"#464C64"} fontSize="sm" mt="1rem">
                              {farm?.landSize ? farm?.landSize : "N/A"}
                            </Text>
                          )}
                        </GridItem>
                        <GridItem>
                          <Text
                            color={"#141D43"}
                            fontSize="md"
                            fontWeight={"700"}
                            fontFamily={"font.roboto"}
                          >
                            Cultivation Capacity (kg)
                          </Text>
                          {editable ? (
                            <Input
                              value={farm?.cultivationCapacity || ""}
                              onChange={(e) =>
                                handleChange(
                                  e,
                                  "cultivationCapacity",
                                  index,
                                  "cultivationCapacity"
                                )
                              }
                              mt="1rem"
                            />
                          ) : (
                            <Text color={"#464C64"} fontSize="sm" mt="1rem">
                              {farm?.cultivationCapacity
                                ? farm?.cultivationCapacity
                                : "N/A"}
                            </Text>
                          )}
                        </GridItem>
                      </Grid>
                    </Box>

                    <Box p="1rem">
                      <Grid
                        templateColumns="repeat(3, 1fr)"
                        marginTop={"1rem"}
                        gap={editable ? "1rem" : ""}
                      >
                        <GridItem colSpan={1}>
                          <Text
                            color={"#141D43"}
                            fontSize="md"
                            fontWeight={"700"}
                            fontFamily={"font.roboto"}
                          >
                            Address
                          </Text>
                          {editable ? (
                            <Input
                              value={farm?.address?.raw_address || ""}
                              onChange={(e) => {
                                handleChange(
                                  e,
                                  "address.raw_address",
                                  index,
                                  "address.raw_address"
                                );
                                getFarmSuggestions(e.target.value);
                                setOpenFarmSuggestions(true);
                              }}
                              onBlur={() => setOpenFarmSuggestions(false)}
                              mt="1rem"
                            />
                          ) : (
                            <Text color={"#464C64"} fontSize="sm" mt="1rem">
                              {farm?.address?.raw_address
                                ? farm?.address?.raw_address
                                : "N/A"}
                            </Text>
                          )}
                          {openFarmSuggestions && (
                            <Box width={"95%"} marginTop={"10px"}>
                              <Card
                                boxShadow={
                                  "rgba(100, 100, 111, 0.2) 0px 10px 26px 0px"
                                }
                              >
                                <Box>
                                  {farmSuggestions
                                    ? farmSuggestions?.map((suggestion) => (
                                        <Box
                                          mb={"1rem"}
                                          mt={"1rem"}
                                          ml={"2rem"}
                                          onMouseDown={() =>
                                            handleSuggestionClick(
                                              suggestion?.description,
                                              index
                                            )
                                          }
                                          _hover={{
                                            background:
                                              "linear-gradient(90deg, rgba(81,187,255,1) 0%, rgba(81,187,255,1) 35%, rgba(164,206,255,1) 100%);",
                                            cursor: "pointer",
                                            color: "#fff",
                                            pl: "10px",
                                          }}
                                        >
                                          {suggestion?.description}
                                        </Box>
                                      ))
                                    : "No results found"}
                                </Box>
                              </Card>
                            </Box>
                          )}
                        </GridItem>
                        <GridItem colSpan={1}></GridItem>
                      </Grid>
                    </Box>
                    <Box p="1rem">
                      <Grid
                        templateColumns="repeat(3, 1fr)"
                        marginTop={"1rem"}
                        gap={editable ? "1rem" : ""}
                      >
                        <GridItem colSpan={1}>
                          <Text
                            color={"#141D43"}
                            fontSize="md"
                            fontWeight={"700"}
                            fontFamily={"font.roboto"}
                          >
                            Latitude
                          </Text>
                          {editable ? (
                            <Input
                              value={
                                farm?.address?.location?.coordinates?.[0] || ""
                              }
                              onChange={(e) =>
                                handleChange(
                                  e,
                                  "address.location.coordinates[0]",
                                  index,
                                  "address.location.coordinates[0]"
                                )
                              }
                              mt="1rem"
                            />
                          ) : (
                            <Text color={"#464C64"} fontSize="sm" mt="1rem">
                              {farm?.address?.location?.coordinates?.[0]
                                ? farm?.address?.location?.coordinates?.[0]
                                : "N/A"}
                            </Text>
                          )}
                        </GridItem>
                        <GridItem>
                          <Text
                            color={"#141D43"}
                            fontSize="md"
                            fontWeight={"700"}
                            fontFamily={"font.roboto"}
                          >
                            Longitude
                          </Text>
                          {editable ? (
                            <Input
                              value={
                                farm?.address?.location?.coordinates?.[1] || ""
                              }
                              onChange={(e) =>
                                handleChange(
                                  e,
                                  "address.location.coordinates[1]",
                                  index,
                                  "address.location.coordinates[1]"
                                )
                              }
                              mt="1rem"
                            />
                          ) : (
                            <Text color={"#464C64"} fontSize="sm" mt="1rem">
                              {farm?.address?.location?.coordinates?.[1]
                                ? farm?.address?.location?.coordinates?.[1]
                                : "N/A"}
                            </Text>
                          )}
                        </GridItem>
                      </Grid>
                    </Box>
                    <Box p="1rem">
                      <Grid
                        templateColumns="repeat(3, 1fr)"
                        marginTop={"1rem"}
                        gap={editable ? "1rem" : ""}
                      >
                        <GridItem colSpan={1}>
                          <Text
                            color={"#141D43"}
                            fontSize="md"
                            fontWeight={"700"}
                            fontFamily={"font.roboto"}
                          >
                            City
                          </Text>
                          {editable ? (
                            <Input
                              value={farm?.address?.city || ""}
                              onChange={(e) =>
                                handleChange(
                                  e,
                                  "address.city",
                                  index,
                                  "address.city"
                                )
                              }
                              mt="1rem"
                            />
                          ) : (
                            <Text color={"#464C64"} fontSize="sm" mt="1rem">
                              {farm?.address?.city
                                ? farm?.address?.city
                                : "N/A"}
                            </Text>
                          )}
                        </GridItem>
                        <GridItem colSpan={1}>
                          <Text
                            color={"#141D43"}
                            fontSize="md"
                            fontWeight={"700"}
                            fontFamily={"font.roboto"}
                          >
                            State
                          </Text>
                          {editable ? (
                            <Select
                              value={farm?.address?.state || ""}
                              onChange={(e) =>
                                handleChange(
                                  e,
                                  "address.state",
                                  index,
                                  "address.state"
                                )
                              }
                              mt="1rem"
                            >
                              <option hidden="true">Select Your State</option>
                              {statesList.map((state, index) => (
                                <option key={index}>{state}</option>
                              ))}
                            </Select>
                          ) : (
                            <Text color={"#464C64"} fontSize="sm" mt="1rem">
                              {farm?.address?.state
                                ? farm?.address?.state
                                : "N/A"}
                            </Text>
                          )}
                        </GridItem>
                        <GridItem colSpan={1}>
                          <Text
                            color={"#141D43"}
                            fontSize="md"
                            fontWeight={"700"}
                            fontFamily={"font.roboto"}
                          >
                            Pincode
                          </Text>
                          {editable ? (
                            <Input
                              value={farm?.address?.pinCode || ""}
                              onChange={(e) =>
                                handleChange(
                                  e,
                                  "address.pinCode",
                                  index,
                                  "address.pinCode"
                                )
                              }
                              mt="1rem"
                            />
                          ) : (
                            <Text color={"#464C64"} fontSize="sm" mt="1rem">
                              {farm?.address?.pinCode
                                ? farm?.address?.pinCode
                                : "N/A"}
                            </Text>
                          )}
                        </GridItem>
                      </Grid>
                    </Box>
                    <Box p="1rem">
                      {" "}
                      {editable && (
                        <ButtonGroup gap="1rem">
                          <Button
                            bg="#52BBFF"
                            mt="2rem"
                            w="193px"
                            h="50px"
                            color={"#fff"}
                            _hover={{ bg: "#52BBFF" }}
                            onClick={() => handleUpdateFarm(farm, farm?._id)}
                          >
                            Update Farm
                          </Button>
                        </ButtonGroup>
                      )}
                    </Box>
                  </Box>
                </AccordionPanel>
              </AccordionItem>
            ))}
          </Accordion>
        ) : (
          <Box mt="1rem" textAlign="center" mb="1rem">
            <Text
              color={"#141D43"}
              fontSize="md"
              fontWeight={"700"}
              fontFamily={"font.roboto"}
            >
              No farm details for this farmer
            </Text>
          </Box>
        )}
      </Box>
    </>
  );
}

export default isAllowed(FarmerDetails);
